import { render, staticRenderFns } from "./BookingsCalendar.vue?vue&type=template&id=28a5ff79&"
import script from "./BookingsCalendar.vue?vue&type=script&lang=js&"
export * from "./BookingsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BookingsCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports